import { render, staticRenderFns } from "./photoUploadMore.vue?vue&type=template&id=3a79afc6&scoped=true"
import script from "./photoUploadMore.vue?vue&type=script&lang=js"
export * from "./photoUploadMore.vue?vue&type=script&lang=js"
import style0 from "./photoUploadMore.vue?vue&type=style&index=0&id=3a79afc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a79afc6",
  null
  
)

export default component.exports